"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isUserCollection = exports.isEnabledCollectionsFeature = exports.isAddedHotelToCollections = exports.getUserToken = exports.getUpdateCollectionUI = exports.getTokenByCollection = exports.getTFToken = exports.getProjectToken = exports.getFetchCollectionsUI = exports.getDeleteHotelUI = exports.getDeleteCollectionUI = exports.getCreateCollectionUI = exports.getCollectionsStore = exports.getCollectionsForAddHotel = exports.getCollectionsByCountry = exports.getCollections = exports.getAddHotelToCollectionUI = exports.getAPIToken = void 0;
var _reselect = require("reselect");
var R = _interopRequireWildcard(require("ramda"));
var _selectors = require("../../../bus/ui/selectors");
var _constants = require("./constants");
var _helpers = require("./helpers");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var domain = function domain(_) {
  return _.collections;
};
var getTokens = (0, _reselect.createSelector)(domain, R.prop('tokens'));
var getAPIToken = exports.getAPIToken = (0, _reselect.createSelector)(getTokens, R.prop('api'));
var getProjectToken = exports.getProjectToken = (0, _reselect.createSelector)(getTokens, R.prop('project'));
var getTFToken = exports.getTFToken = (0, _reselect.createSelector)(getTokens, R.prop('tf'));
var getUserToken = exports.getUserToken = (0, _reselect.createSelector)(getTokens, R.prop('user'));
var isEnabledCollectionsFeature = exports.isEnabledCollectionsFeature = (0, _reselect.createSelector)(getAPIToken, getProjectToken, getTFToken, getUserToken, function () {
  for (var _len = arguments.length, tokens = new Array(_len), _key = 0; _key < _len; _key++) {
    tokens[_key] = arguments[_key];
  }
  return R.all(Boolean, tokens);
});
var getFetchCollectionsUI = exports.getFetchCollectionsUI = R.partialRight(_selectors.getUI, [{
  key: _constants.FETCH_COLLECTIONS_UI_KEY
}]);
var getCollectionsStore = exports.getCollectionsStore = (0, _reselect.createSelector)(domain, R.prop('store'));
var getCollection = function getCollection(key, collections, type) {
  return R.map(R.set(R.lensProp('type'), type), R.propOr([], key, collections));
};
var getCollections = exports.getCollections = (0, _reselect.createSelector)(getCollectionsStore, getUserToken, getTFToken, getProjectToken, function (collections, user, tf, project) {
  return R.call(R.pipe(R.append(getCollection(user, collections, _constants.COLLECTION_TYPES.USER)), R.append(getCollection(tf, collections, _constants.COLLECTION_TYPES.TF)), R.append(getCollection(project, collections, _constants.COLLECTION_TYPES.PROJECT)), R.flatten), []);
});
var getCollectionsForAddHotel = exports.getCollectionsForAddHotel = (0, _reselect.createSelector)(getCollectionsStore, getUserToken, getTFToken, function (collections, user, tf) {
  return R.call(R.pipe(R.append(getCollection(user, collections, _constants.COLLECTION_TYPES.USER)), R.append(getCollection(tf, collections, _constants.COLLECTION_TYPES.TF)), R.flatten), []);
});
var getCollectionsByCountry = exports.getCollectionsByCountry = function getCollectionsByCountry() {
  return (0, _reselect.createSelector)(getCollections, function (_, _ref) {
    var countryID = _ref.countryID;
    return countryID;
  }, function (collections, countryID) {
    var disabledCollections = R.filter(function (_ref2) {
      var hotels = _ref2.hotels;
      return R.all(function (_ref3) {
        var country = _ref3.country;
        return country.id !== countryID;
      }, hotels);
    }, collections);
    return R.call(R.pipe(R.concat, R.map(R.over(R.lensProp('hotels'), R.sort(function (_ref4) {
      var country = _ref4.country;
      return country.id === countryID ? -1 : 0;
    })))), R.filter(function (collection) {
      return !R.includes(collection, disabledCollections);
    }, collections), R.map(R.set(R.lensProp('withoutHotelsByCountry'), true), disabledCollections));
  });
};
var getAddHotelToCollectionUI = exports.getAddHotelToCollectionUI = R.partialRight(_selectors.getUI, [{
  key: _constants.ADD_HOTEL_TO_COLLECTION_UI_KEY
}]);
var getTokenByCollection = exports.getTokenByCollection = (0, _reselect.createSelector)(getCollections, function (_, _ref5) {
  var collectionID = _ref5.collectionID;
  return collectionID;
}, getTokens, function (collections, collectionID, tokens) {
  return R.call(R.pipe(R.find(function (_ref6) {
    var id = _ref6.id;
    return id === collectionID;
  }), R.when(Boolean, function (_ref7) {
    var type = _ref7.type;
    return tokens[type];
  })), collections);
});
var isAddedHotelToCollections = exports.isAddedHotelToCollections = function isAddedHotelToCollections() {
  return (0, _reselect.createSelector)(getCollectionsStore, function (_ref8) {
    var hotelID = _ref8.hotelID;
    return hotelID;
  }, function (store, hotelID) {
    return R.call(R.pipe(R.values, R.map(function (collections) {
      return R.map(R.prop('hotels'), collections);
    }), R.flatten, R.any(function (_ref9) {
      var id = _ref9.id;
      return id === hotelID;
    })), store);
  });
};
var isUserCollection = exports.isUserCollection = function isUserCollection() {
  return (0, _reselect.createSelector)(getCollectionsStore, getUserToken, getTFToken, function (_, _ref0) {
    var id = _ref0.id;
    return id;
  }, function (store, userKey, tfKey, collectionID) {
    return R.call(R.pipe(function (_ref1) {
      var a = _ref1[userKey],
        b = _ref1[tfKey];
      return R.concat(a, b);
    }, R.any(function (_ref10) {
      var id = _ref10.id;
      return id === collectionID;
    })), store);
  });
};
var getCreateCollectionUI = exports.getCreateCollectionUI = R.partialRight(_selectors.getUI, [{
  key: _constants.CREATE_COLLECTION_UI_KEY
}]);
var getDeleteCollectionUI = exports.getDeleteCollectionUI = function getDeleteCollectionUI(collectionID) {
  return R.partialRight(_selectors.getUI, [{
    key: (0, _helpers.createDeleteCollectionUIKey)(collectionID)
  }]);
};
var getDeleteHotelUI = exports.getDeleteHotelUI = function getDeleteHotelUI(hotelID) {
  return R.partialRight(_selectors.getUI, [{
    key: (0, _helpers.createDeleteHotelUIKey)(hotelID)
  }]);
};
var getUpdateCollectionUI = exports.getUpdateCollectionUI = function getUpdateCollectionUI(collectionID) {
  return R.partialRight(_selectors.getUI, [{
    key: (0, _helpers.createUpdateCollectionUIKey)(collectionID)
  }]);
};